import { Box, Collapse, Typography } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import {
  getDrugAmountOfUseOptions,
  getDrugHowToUseOptions,
  getDrugListInArea,
  getDrugUseTimeOptions,
  getListOfAdvices,
  postAdvice,
  postAdvice1,
} from "../../../../api/area";
import DownArrow from "../../../../assets/SVG/downArrow";
import PlusInage from "../../../../assets/SVG/plusInage";
import CustomizedHook from "../../../project/autocomplatePro";
import { InputCreateProject } from "../../../project/createProjectPop";
import BookmarkDrugs from "./bookmarkDrugs";
import TableUserDrug from "./tableUserDrug";

export default function DrugInParvande({ parvande, moduleId, areaId }) {
  const [collapseAz, setCollapseAz] = useState();
  const [optionDrugTime, setOptionDrugTime] = useState();
  const [optionUseDrug, setOptionUseDrug] = useState();
  const [optionCountUseDrug, setOptionCountUseDrug] = useState();
  const [drugName, setDrugName] = useState();
  const [areaDrugId, setAreaDrugId] = useState();
  const [dataTable, setDataTable] = useState([]);
  const [modalBookmarkDrugs, setModalBookmarkDrugs] = useState();
  const [data, setData] = useState({
    amount: 0,
    amountOfUse: "",
    howToUse: "",
    useTime: "",
    description: "",
  });

  useEffect(() => {
    if (collapseAz) {
      getDrugUseTimeOptions()
        .then((x) => setOptionDrugTime(x))
        .catch(() => {});
      getDrugHowToUseOptions()
        .then((x) => setOptionUseDrug(x))
        .catch(() => {});
      getDrugAmountOfUseOptions()
        .then((x) => setOptionCountUseDrug(x))
        .catch(() => {});
      getDrugListInArea(
        window.location.search.split("?", 3)[1].split("&", 3)[0]
      )
        .then((x) => {
          setDrugName(
            x.map((z) => ({
              value: z?.drugInfo?.name,
              areaDrugId: z?.id,
            }))
          );
        })
        .catch(() => {});
    }
  }, [collapseAz]);

  useEffect(() => {
    if (areaId && collapseAz) {
      getListOfAdvices(
        areaId,
        `&patientId=${window.location.search.split("?", 3)[1].split("&", 6)[3]}`
      )
        .then((x) => setDataTable(x[0].drugs))
        .catch(() => {});
    }
  }, [areaId, collapseAz]);

  // console.log(data);
  // console.log(dataTable);

  return (
    <>
      <BookmarkDrugs
        open={modalBookmarkDrugs}
        setOpen={setModalBookmarkDrugs}
        areaId={areaId}
        parvandeh
        setRowData={setDataTable}
        rowData={dataTable}
      />
      <Box
        height={"80vh"}
        sx={{
          overflow: "auto",
          "::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        {parvande && (
          <Typography
            sx={{ cursor: "pointer" }}
            mt="20px"
            fontWeight="bold"
            color={"var(--emr-darkblue)"}
          >
            {"داروهای دریافتی"}
          </Typography>
        )}
        <Box
          onClick={() => setCollapseAz(!collapseAz)}
          bgcolor="#EFF1F7"
          borderRadius={"7px"}
          p="10px"
          display="flex"
          justifyContent={"space-between"}
          alignItems="center"
          mt="20px"
          sx={{ cursor: "pointer" }}
        >
          <Typography color="var(--emr-darkblue)">
            {"اطلاعات نسخه دارو"}
          </Typography>
          <DownArrow transform={collapseAz} />
        </Box>
        <Collapse in={collapseAz} timeout="auto">
          <Box mt="-5px" bgcolor="#EFF1F7" p="20px">
            <Box display={"flex"} gap="30px 10px" flexWrap={"wrap"}>
              <Box
                width={"205px"}
                mt="20px"
                borderRadius={"11px"}
                gap="10px"
                bgcolor="#42C3CF"
                display={"flex"}
                alignItems="center"
                p="5px 10px"
                onClick={() => setModalBookmarkDrugs(!modalBookmarkDrugs)}
                sx={{ cursor: "pointer" }}
              >
                <PlusInage />
                <Typography color="white">{"مشاهده داروهای منتخب"}</Typography>
              </Box>
              <Box width={"225px"}>
                <CustomizedHook
                  width={"225px"}
                  multiple
                  placeholder={"نام دارو را بنوسید"}
                  label="نام دارو"
                  options={drugName}
                  onChange={(e, newValue) => {
                    setAreaDrugId(newValue);
                  }}
                />
              </Box>
              <InputCreateProject
                width={"200px"}
                placeholder={"تعداد دارو را بنوسید"}
                label="تعداد دارو"
                onChange={(e) => {
                  setData({ ...data, amount: e.target.value });
                }}
              />
              <Box width={"225px"}>
                <CustomizedHook
                  width={"225px"}
                  multiple
                  placeholder={"مقدار مصرف را بنوسید"}
                  label="مقدار مصرف"
                  options={optionCountUseDrug}
                  onChange={(e, newValue) => {
                    setData({ ...data, amountOfUse: newValue.key });
                  }}
                />
              </Box>
              <Box width={"225px"}>
                <CustomizedHook
                  width={"225px"}
                  multiple
                  placeholder={"طریقه مصرف را بنوسید"}
                  label="طریقه مصرف"
                  options={optionUseDrug}
                  onChange={(e, newValue) => {
                    setData({ ...data, howToUse: newValue.key });
                  }}
                />
              </Box>
              <Box width={"200px"}>
                <CustomizedHook
                  width={"225px"}
                  multiple
                  placeholder={"زمان مصرف را بنوسید"}
                  label="زمان مصرف"
                  options={optionDrugTime}
                  onChange={(e, newValue) => {
                    setData({ ...data, useTime: newValue.key });
                  }}
                  // value={
                  //   states.find((state) => state.name === stepOne.state) ||
                  //   dataLoc?.states ||
                  //   null
                  // }
                />
              </Box>
              {/* <InputCreateProject
              width={"200px"}
              
            /> */}
            </Box>
            <Box mt="30px" display={"flex"} justifyContent="end">
              <botton
                style={{
                  border: "none",
                  backgroundColor: "var(--emr-darkblue)",
                  color: "white",
                  padding: "5px 40px",
                  borderRadius: "10px",
                  marginLeft: "20px",
                  cursor: "pointer",
                  zIndex: "1",
                  // height: "30px",
                }}
                onClick={() => {
                  if (moduleId) {
                    postAdvice(
                      window.location.search.split("?", 3)[1].split("&", 4)[3],
                      moduleId,
                      areaDrugId?.areaDrugId,
                      data
                    )
                      .then((x) => {
                        // setDataTable([
                        //   ...dataTable,
                        //   {
                        //     amountOfUseFa: data?.amountOfUse,
                        //     drugName: areaDrugId?.value,
                        //     howToUseFa: data?.howToUse,
                        //     useTimeFa: data?.useTime,
                        //     suggestCount: Number(data?.amount),
                        //   },
                        // ]);
                        getListOfAdvices(
                          areaId,
                          `&patientId=${window.location.search.split("?", 3)[1].split("&", 6)[3]}`
                        )
                          .then((z) => setDataTable(z[0].drugs))
                          .catch(() => {});
                        toast.success("ثبت شد");
                        toast.success("ثبت شد");
                      })
                      .catch(() => {});
                  }
                  else{
                    postAdvice1(
                      window.location.search.split("?", 3)[1].split("&", 4)[3],
                      // moduleId,
                      areaDrugId?.areaDrugId,
                      data
                    )
                      .then((x) => {
                        // setDataTable([
                        //   ...dataTable,
                        //   {
                        //     amountOfUseFa: data?.amountOfUse,
                        //     drugName: areaDrugId?.value,
                        //     howToUseFa: data?.howToUse,
                        //     useTimeFa: data?.useTime,
                        //     suggestCount: Number(data?.amount),
                        //   },
                        // ]);
                        getListOfAdvices(
                          areaId,
                          `&patientId=${window.location.search.split("?", 3)[1].split("&", 6)[3]}`
                        )
                          .then((z) => setDataTable(z[0].drugs))
                          .catch(() => {});
                        toast.success("ثبت شد");
                      })
                      .catch(() => {});
                  }
                  // console.log(dataTable);
                }}
              >
                ثبت
              </botton>
            </Box>
            {dataTable?.length > 0 && (
              <TableUserDrug
                areaId={areaId}
                parvandeh
                setRowData={setDataTable}
                rowData={dataTable}
              />
            )}
          </Box>
        </Collapse>
      </Box>
    </>
  );
}
